export const countDifference = (enteredCount, currentCount) => {
  if (enteredCount === null || enteredCount === undefined || enteredCount === '') {
    return null;
  }

  if (currentCount === null || currentCount === undefined || currentCount === '') {
    return null;
  }

  const entered = Number(enteredCount);
  const current = Number(currentCount ?? 0);

  if (!Number.isFinite(entered) || !Number.isFinite(current)) {
    return null;
  }

  return entered - current;
};
